import { render, staticRenderFns } from "./ConsultoriaAnexoForm.vue?vue&type=template&id=4c709884"
import script from "./ConsultoriaAnexoForm.vue?vue&type=script&lang=js"
export * from "./ConsultoriaAnexoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports